import React from 'react'
import {
    Container, Button,
    Row, Col, Label,
    Input,
} from 'reactstrap'
import {
  queryEnvironment,
} from '../model/request/environment'
import dateFormat from 'dateformat'
import DateTextField from '../view/DateTextField'
import { JustDate } from '../model/JustDate'
import NumberTextField from '../view/NumberTextField'
import UplotReact from 'uplot-react';

import 'uplot/dist/uPlot.min.css';

const EnvironmentalUPlot = ({ rawData, label = "temp" }) => {
  const data = [
    rawData.map(d => d.end_time),
    rawData.map(d => d.min[label]),
    rawData.map(d => d.mean[label]),
    rawData.map(d => d.max[label]),
  ];

  const style = getComputedStyle(document.documentElement)
  const boundaryColor = style.getPropertyValue('--chart-boundary-color').trim() || '#94a3b8'
  const meanColor = style.getPropertyValue('--chart-mean-color').trim() || '#2563eb'
  const meanFill = style.getPropertyValue('--chart-mean-fill').trim() || 'rgba(37, 99, 235, 0.1)'
  const textColor = style.getPropertyValue('--chart-text-color').trim() || '#3c3c3c'

  const options = {
    title: `${label.toUpperCase()} over Time`,
    width: 800,
    height: 400,
    cursor: {
      drag: { setScale: false },
    },
    scales: {
      x: { time: true },
    },
    series: [
      {},
      {
        label: "Min",
        stroke: boundaryColor,
        width: 1,
        dash: [5, 5],
      },
      {
        label: "Mean",
        stroke: meanColor,
        width: 2,
        fill: meanFill,
      },
      {
        label: "Max",
        stroke: boundaryColor,
        width: 1,
        dash: [5, 5],
      },
    ],
    axes: [
      {
        stroke: textColor,
        values: (self, splits) => splits.map(v => {
          const d = new Date(v * 1000);
          return d.getHours() + ":" + d.getMinutes().toString().padStart(2, '0');
        }),
      },
      {
        label: label,
        stroke: textColor,
      }
    ],
  };

  return (
    <div className="uplot-container">
      <UplotReact options={options} data={data} />
    </div>
  );
};


function timeToSeconds(time='0:00') {
  const split = time.split(':')
  if (split.length !== 2) {
    return 0
  }
  return 60 * (Number.parseFloat(split[0]) * 60 + Number.parseFloat(split[1]))
}

class EnvironnmentViewController extends React.Component {

    // MARK: Override Functions

    constructor(props) {
        super(props)

        let startDate = new Date()
        startDate.setDate(startDate.getDate()-1)

        let endDate = new Date()
        endDate.setDate(endDate.getDate()+1)

        this.state = {
          'data': [],
          'is_selected': [],
          'name': 'outside_super_ficci_after_paint',
          'interval': 30,
          'start_date': new JustDate(startDate),
          'end_date': new JustDate(endDate),
          'start_time': '0:00',
          'end_time': '24:00',
        }
    }

    search() {
      this.props.turnOnLoader()
      queryEnvironment({
        'reader_name': this.state.name,
        'interval': Number.parseFloat(this.state.interval),
        'min_interval': Math.floor(this.state.start_date.toDate().getTime() / 1000) + timeToSeconds(this.state.start_time),
        'max_interval': Math.floor(this.state.end_date.toDate().getTime() / 1000) + timeToSeconds(this.state.end_time),
        'limit': 1000,
        // 'is_forward': true,
      }).then(
        (result) => {
          this.setState({
            'data': result,
          })
          this.props.turnOffLoader()
        },
        (error) => {
          this.props.showError(error)
          this.props.turnOffLoader()
        }
      )
    }

    renderGraphLabels() {
      let keys = []
      if (this.state.data.length > 0) {
        keys = Object.keys(this.state.data[0].min)
      }

      return <>
        {
      keys.map((key) => {
        const isSelected = this.state.is_selected.indexOf(key) !== -1
        return <>
          <Label>{key}</Label>
            <Input
              type="checkbox"
              checked={isSelected}
              onChange={(e) => {
                if (isSelected) {
                  this.setState({
                      'is_selected': this.state.is_selected.filter((x) => x !== key)
                  })
                } else {
                  this.setState({
                      'is_selected': [key, ...this.state.is_selected]
                  })
                }
              }}/>
          </>
      })
      }
      {
        this.state.is_selected.map((x) => {
          return EnvironmentalUPlot({ rawData: this.state.data, label: x})
        })
      }
      </>
    }

    render() {
      return <Container>
        <Row>
          <Col><Label
            style={{
              'fontSize': '20pt',
              'fontWeight': '400',
            }}
          >Name</Label>
          </Col>
          <Col><Label
            style={{
              'fontSize': '20pt',
              'fontWeight': '400',
            }}
          >Interval</Label>
          </Col>
        </Row>
        <Row>
          <Col>
            <Input
              type='text'
              value={this.state.name}
              onChange={(e) => this.setState({'name': e.target.value})} />
          </Col>
          <Col>
            <NumberTextField
              style={{
                'textAlign': 'right',
              }}
              value={this.state.interval}
              onChange={(e) => {
                this.setState({
                  'interval': e.target.value
                })
              }}/>
          </Col>
        </Row>
        <Row>
          <Col><Label
            style={{
              'fontSize': '20pt',
              'fontWeight': '400',
            }}
          >Start Date</Label>
          </Col>
          <Col><Label
            style={{
              'fontSize': '20pt',
              'fontWeight': '400',
            }}
          >End Date</Label>
          </Col>
        </Row>
        <Row>
          <Col>
            <DateTextField
              value={this.state.start_date}
              showModal={this.props.showModal}
              closeModal={this.props.closeModal}
              onChange={(newDate) => {
                  this.setState({
                    'start_date': newDate,
                  })
              }}
            />
          </Col>
          <Col>
            <Input
              value={this.state.start_time}
              onChange={(e) => {
                this.setState({
                  'start_time': e.target.value
                })
              }} />
          </Col>
          <Col>
            <DateTextField
                value={this.state.end_date}
                showModal={this.props.showModal}
                closeModal={this.props.closeModal}
                onChange={(newDate) => {
                    this.setState({
                      'end_date': newDate,
                    })
                }}
            />
          </Col>
          <Col>
            <Input
              value={this.state.end_time}
              onChange={(e) => {
                this.setState({
                  'end_time': e.target.value,
                })
              }} />
          </Col>
        </Row>
        <Button
          color='primary'
          onClick={() => {
              this.search()
          }}
        >Search</Button>
        <Row>
          <Col>
            {this.renderGraphLabels()}
          </Col>
        </Row>
      </Container>
    }
}

export default EnvironnmentViewController

